import { Shark, Utils } from "shark-mvc";

import "Models/Quotation";
import ViewBase from "../ViewBase";

import templateContent from "./visit-list.html";

import { activityReportComponent } from "../../_shark_jaws/components/activityReportComponent";
import agentFilterComponent from "../../_shark_components/agentFilter/agentFilterComponent";
import { clientFullRecapComponent } from "./clientFullRecapComponent";
import { dateRangeFilterComponent } from "../../_shark_jaws/components/dateRangeFilter/dateRangeFilterComponent";
import exportCSVComponent from "../../components/exportCSV/exportCSVComponent";
import followUpComponent from "../../components/followUp/followUpComponent";
import getMoreComponent from "../../components/getMore/getMoreComponent";
import liveSearchComponent from "../../_shark_components/liveSearch/liveSearchComponent";
import mainNavComponent from "../../_shark_jaws/components/mainNavComponent";
import printButtonComponent from "../../_shark_components/printButton/printButtonComponent";
import refreshListButtonComponent from "../../components/refreshListButton/refreshListButtonComponent";
import sampleRequestModalComponent from "../../components/sampleRequestModal/sampleRequestModalComponent";
import visitEditView from "./visitEditView";
import { visitManager } from "../../_shark_jaws/managers/visitManager";
import waitBoxComponent from "../../_shark_components/waitBox/waitBoxComponent";

class VisitListView extends ViewBase {
	constructor () {
		super("visitListView");
		this.setTemplate(templateContent);
	}

	activateSingleFilterBtn_clickHandler (event, data) {
		const singleFilterActivated = data.filter;
		const visitListActiveFilters = Shark.get("visitListActiveFilters");

		visitListActiveFilters.showConcluded = singleFilterActivated === "showConcluded";
		visitListActiveFilters.showDevelop = singleFilterActivated === "showDevelop";
		visitListActiveFilters.showManaging = singleFilterActivated === "showManaging";
		visitListActiveFilters.showNotInterested = singleFilterActivated === "showNotInterested";
		visitListActiveFilters.showNotReachable = singleFilterActivated === "showNotReachable";

		visitListActiveFilters.set({
			__triggerer: !visitListActiveFilters.__triggerer,
		});
	}

	beforeLoad () {
		activityReportComponent.set("__reportType", "report");
		liveSearchComponent.behavior = "database";
		followUpComponent.set("targetItem", null);
		sampleRequestModalComponent.set({
			referenceList: "visitList",
			referenceType: "report",
		});

		if (Shark.get("visitList").length === 0) {
			if (Shark.get("agentList").length === 0) {
				// userManager.getList();
			}
			else {
				this.refreshList();
			}
		}

		// N° SCHEDE CANTIERE	N° CANTIERI	IN ATTESA	PARTITI	CONCLUSI	NON CONFORMITA	Follow up

		exportCSVComponent.set({
			savedFileBaseName: "Lista Report",
			replaceMaps: {
				"extraData.interestSolutions": {
					1: "Pavimenti in resina",
					2: "Riqualificazione Pavimenti",
					3: "Pavimenti in Calcestruzzo",
					4: "Pavimentazione drenante in graniglia",
					5: "Pavimentazioni per aree ludiche e sportive",
					6: "Prodotti per il trattamento di strade naturali",
					7: "Pavimentazioni per la marina",
				},
				"extraData.providedSpecifications": {
					true: "Sì",
					false: "No",
				},
			},
			exportMap: {
				name: "Report",
				id: "reportFieldMap",
				fields: {
					//Numero
					__createdAtLabel: "Data Creazione",
					prospectName: "Azienda",
					role: "Ruolo contatto",
					//Linea/Prodotto
					prospectSector: "Settore merceologico",
					"contactExtraData.leadRequestedArea": "Mq",
					"extraData.interestSolutions": "Interessato a",
					contactName: "Nome e Cognome",
					email: "Email",
					phone: "Recapito telefonico",
					region: "Regione",
					province: "Provincia",
					address: "Indirizzo",
					city: "Città",
					__agentFullName: "Venditore",
					__referenceDateLabel: "Data Visita",
					__statusLabel: "Stato",
					__outcomeLabel: "Esito visita",
					"extraData.providedSpecifications": "Fornito voce capitolato",
					__futureContactDateLabel: "Ricontattare in data",
					notInterestedReason: "Non interessato perché",
					__contactOriginLabel: "Tipologia Contatto",
					__contactSourceLabel: "Origine Contatto",
					//Origine  Contatto in dettaglio
					siteInfoSheetCount: "N° Schede Informative",
					quotationPendingCount: "N° Offerte in attesa",
					quotationAcceptedCount: "N° Offerte approvate",
					quotationRefusedCount: "N° Offerte rifiutate",
					constructionSiteCardCount: "N° Schede Cantiere",
					constructionSitePendingCount: "N° Cantieri in attesa",
					constructionSiteCount: "N° Cantieri partiti",
					constructionSiteClosedCount: "N° Cantieri conclusi",
					// quotationRefusedCount: "N° Non Conformità",
					notes: "note",
					latestFollowUp: "Ultimo Folllow up",
				}
			}
		});
	}

	refreshList (range = null) {
		waitBoxComponent.show();
		let incrementalRequest = false;

		if (!range) {
			getMoreComponent.views[this.className] = {
				currentPage: 0,
			};
			range = getMoreComponent.getCurrentPageRangeForView(this.className);
		}
		else {
			incrementalRequest = true;
		}

		const [agentFilter, dateRangeFilter, visitListActiveFilters] = Shark.get(["agentFilter", "dateRangeFilter", "visitListActiveFilters"]);
		// const filters = {
		// 	showAlredyClients: visitListActiveFilters.showAlredyClients,
		// 	showAssignedProspect: visitListActiveFilters.showAssignedProspect,
		// 	showNewContacts: visitListActiveFilters.showNewContacts,
		// };//siteInfoSheetListActiveFilters.export();
		const filters = visitListActiveFilters.export();
		delete filters.hasFilterActive;

		if (agentFilter.agentGuid !== "") {
			filters.agentGuid = agentFilter.agentGuid;
		}

		if (!dateRangeFilter.ignoreDateRange) {
			filters.dateFrom = dateRangeFilter.__from;
			filters.dateTo = dateRangeFilter.__to;
		}

		if (this.textFilters) {
			Object.assign(filters, this.textFilters);
		}


		// visitManager.getList(dateFrom, dateTo, range, incrementalRequest)
		return visitManager.getFilteredList({filters, range, incrementalRequest})
		.then(() => {
			waitBoxComponent.hide();

			Shark.render();
			return true;
		});
	}

	singleItemBox_clickHandler (event, data) {
		if (event.target.closest(".preventRowClick") !== null) {
			return;
		}
		// if (event.target.classList.contains("notClickable") || event.target.classList.contains("statusCell")) {
		// 	return;
		// }

		let selectedVisit = Utils.safp(Shark.get("visitList"), "guid", data.guid);
		console.log({ selectedVisit });
		followUpComponent.set("targetItem", selectedVisit);
		
		Shark.set("currVisit", selectedVisit);
		Shark.openPage(visitEditView);
	}

	updateActivityStatusBtn_clickHandler (event, data) {
		const currVisit = Utils.safp(Shark.get("visitList"), "guid", data.guid);

		if (currVisit) {
			visitManager.updateActivityStatus(currVisit.guid)
			.then(response => {
				console.log({response});
				this.refreshList();
			});
		}
	}

	updateTextFilters (searchKey) {
		if (searchKey && searchKey !== "") {
			this.textFilters = {
				name: searchKey,
			};
		}
		else {
			this.textFilters = null;
		}

		this.refreshList()
		.then(() => {
			if (searchKey !== "") {
				liveSearchComponent.setFocus();
			}
		});
	}

	userManager_listChangedHandler () {
		visitListView.refreshList();
	}





		
	afterComponentsPreRender () {
		let visitList = Shark.get("visitList");

		if (visitList) {
			// const [agentFilter, dateRangeFilter, visitListActiveFilters] = Shark.get(["agentFilter", "dateRangeFilter", "visitListActiveFilters"]);
			let counter = 0;
			let showDateRangeInfo = false;

			visitList.forEach((item, index) => {
				// if (!visitListActiveFilters.hasFilterActive) {
				// 	item.__render = false;
				// }
				// else if (!dateRangeFilter.ignoreDateRange && (item.__referenceDate < dateRangeFilter.__from || item.__referenceDate > dateRangeFilter.__to) && (item.__updatedAt < dateRangeFilter.__from || item.__updatedAt > dateRangeFilter.__to)) {
				// 	item.__render = false;
				// }
				// else {
				// 	item.__render = (
				// 		 (item.extraData.isNewContact && visitListActiveFilters.showNewContacts)
				// 		|| (item.isFromLead && visitListActiveFilters.showAssignedProspect)
				// 		|| (!item.extraData.isNewContact && !item.isFromLead && visitListActiveFilters.showAlredyClients)
				// 	);
				// }

				// if (item.__render) {
				// 	item.__render = (
				// 		((item.outcome != "5") || (item.outcome == "5" && visitListActiveFilters.showNotInterested))
				// 		&& ((item.outcome != "6") || (item.outcome == "6" && visitListActiveFilters.showNotReachable))
				// 		// && ((item.__statusForFilter !== "concluded") || (item.__statusForFilter === "concluded" && visitListActiveFilters.showConcluded))
				// 		&& ((item.__statusForFilter !== "concludedOk") || (item.__statusForFilter === "concludedOk" && visitListActiveFilters.showConcluded && visitListActiveFilters.showConcludedOk))
				// 		&& ((item.__statusForFilter !== "concludedKo") || (item.__statusForFilter === "concludedKo" && visitListActiveFilters.showConcluded && visitListActiveFilters.showConcludedKo))
				// 		&& ((item.__statusForFilter !== "managing") || (item.__statusForFilter === "managing" && visitListActiveFilters.showManaging))
				// 		&& ((item.__statusForFilter !== "develop") || (item.__statusForFilter === "develop" && visitListActiveFilters.showDevelop))
				// 	);
				// }

				// if (item.__render && agentFilter.agentGuid !== "" && item.agentGuid !== agentFilter.agentGuid) {
				// 	item.__render = false;
				// }

				if (!dateRangeFilterComponent.includeDate(item.__referenceDate) && dateRangeFilterComponent.includeDate(item.__updatedAt)) {
					item.__updatedAtDateLabel = "<span class=\"filter-matched-field-display\">" + item.__updatedAtLabel + "</span>";
					showDateRangeInfo = true;
				}
				else {
					item.__updatedAtDateLabel = item.__updatedAtLabel;
				}


				// if (item.__render) {
				item.__render = true;
				item.__displayIndex = counter + 1;
				item.__index = index;
				counter++;
				// }
			});

			exportCSVComponent.set({
				listToExport: Shark.get("visitList").filter(item => item.__render)
			});

			this.set({
				__showDateRangeInfo: showDateRangeInfo,
			});

			Shark.set({activityReport: activityReportComponent.extractReport(visitList)});
		}
	}

	beforeRender () {
		const visitList = Shark.get("visitList");

		followUpComponent.set({
			sourceList: visitList
		});
	}

	init () {
		this.addComponents([activityReportComponent, agentFilterComponent, clientFullRecapComponent, dateRangeFilterComponent, exportCSVComponent, followUpComponent, getMoreComponent, liveSearchComponent, mainNavComponent, printButtonComponent, refreshListButtonComponent, sampleRequestModalComponent, waitBoxComponent]);

		const filterButtonListStatus = [
			{
				id: "showConcluded",
				label: "conclusi",
			},
			{
				id: "showDevelop",
				label: "da sviluppare",
			},
			{
				id: "showManaging",
				label: "in gestione",
			},
			{
				id: "showNotInterested",
				label: "non interessati",
			},
			{
				id: "showNotReachable",
				label: "non raggiungibili",
			}
		];

		const filtersStatus = this.getFiltersStatus();

		const visitListActiveFilters = Shark.getInstance("__smart__", {
			hasFilterActive: true,

			agentGuid: "",
			province: "",
			showAlredyClients: filtersStatus ? filtersStatus.showAlredyClients : true,
			showAssignedProspect: filtersStatus ? filtersStatus.showAssignedProspect : true,
			showNewContacts: filtersStatus ? filtersStatus.showNewContacts : true,

			showConcluded: filtersStatus ? filtersStatus.showConcluded : false,
			showConcludedOk: filtersStatus ? filtersStatus.showConcludedOk : true,
			showConcludedKo: filtersStatus ? filtersStatus.showConcludedKo : true,
			showDevelop: filtersStatus ? filtersStatus.showDevelop : true,
			showManaging: filtersStatus ? filtersStatus.showManaging : true,
			showNotInterested: filtersStatus ? filtersStatus.showNotInterested : false,
			showNotReachable: filtersStatus ? filtersStatus.showNotReachable : false,
			showWithNewFollowUp: filtersStatus ? filtersStatus.showWithNewFollowUp : true,
			showWithoutNewFollowUp: filtersStatus ? filtersStatus.showWithoutNewFollowUp : true,
			
			subFiltersActive: filtersStatus ? filtersStatus.subFiltersActive : true,
			__showConcludedSubFilters: filtersStatus ? (filtersStatus.subFiltersActive && filtersStatus.showConcluded) : false,

			__triggerer: false,
		});

		visitListActiveFilters.on("dataChanged", function () {
			visitListView.saveFiltersStatus(this);

			console.log(arguments);
			this.hasFilterActive = this.showAlredyClients || this.showAssignedProspect || this.showNewContacts;// || this.showNotInterested || this.showSiteInfoSheetCreated;
			this.subFiltersActive = this.showAlredyClients || this.showAssignedProspect || this.showNewContacts;

			this.__showConcludedSubFilters = this.subFiltersActive && this.showConcluded;

			const hasActiveSubfilters = this.showConcluded || this.showDevelop || this.showManaging || this.showNotInterested || this.showNotReachable;
			
			if (hasActiveSubfilters && this.hasFilterActive && (this.showWithNewFollowUp || this.showWithoutNewFollowUp)) {
				visitListView.refreshList();
			}
			else {
				Shark.set({visitList: []});
				// Shark.render();
			}
		});

		Shark.set({
			agentList: Shark.get("agentList") || [],
			filterButtonListStatus,
			visitList: Shark.get("visitList") || [],
			visitListActiveFilters
		});

		getMoreComponent.views[this.className] = {
			currentPage: 0,
		};

		this.set({
			__htmlTitle: "Report | IPM HUB"
		});
	}

	statusCell_clickHandler (event, data) {
		const currVisit = Utils.safp(Shark.get("visitList"), "guid", data.guid);

		if (currVisit) {
			Shark.set("currVisit", currVisit);
			clientFullRecapComponent.show(currVisit.clientGuid);
		}
	}
}

const visitListView = new VisitListView();

Shark.registerView(visitListView);

export default visitListView;
